import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export interface User {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
}

export interface AuthState {
  tableauToken: string | null;
  user: User | null;
  token: string | null;
}

const initialState: AuthState = {
  tableauToken: localStorage.getItem('tableauToken') ?? null,
  user: (() => {
    const userString = localStorage.getItem('user');
    if (userString === null) return null;
    try {
      return JSON.parse(userString) as User;
    } catch {
      return null;
    }
  })(),
  token: localStorage.getItem('jwtToken') ?? null
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthData: (state, action: PayloadAction<AuthState>) => {
      state.tableauToken = action.payload.tableauToken;
      state.user = action.payload.user;
      state.token = action.payload.token;
      if (action.payload.tableauToken !== null) {
        localStorage.setItem('tableauToken', action.payload.tableauToken);
      } else {
        localStorage.removeItem('tableauToken');
      }
      if (action.payload.user !== null) {
        localStorage.setItem('user', JSON.stringify(action.payload.user));
      } else {
        localStorage.removeItem('user');
      }
      if (action.payload.token !== null) {
        localStorage.setItem('jwtToken', action.payload.token);
      } else {
        localStorage.removeItem('jwtToken');
      }
    },
    clearAuthData: (state) => {
      state.tableauToken = null;
      state.user = null;
      state.token = null;
      localStorage.removeItem('tableauToken');
      localStorage.removeItem('user');
      localStorage.removeItem('jwtToken');
    },
    updateTableauToken: (state) => {
      const sessionToken = localStorage.getItem('tableauToken');
      if (sessionToken != null) {
        state.tableauToken = sessionToken;
      }
    },
  },
});

export const { setAuthData, clearAuthData, updateTableauToken } = authSlice.actions;
export default authSlice.reducer;